// extracted by mini-css-extract-plugin
export var active = "_1y-9";
export var backButton = "_1y-8";
export var clone = "_1y-e";
export var collapseBar = "_1y-k";
export var collapseMode = "_1y-m";
export var collapsed = "_1y-o";
export var dimmed = "_1y-i";
export var dragHandle = "_1y-c";
export var dropdownIcon = "_1y-g";
export var expanding = "_1y-n";
export var hidden = "_1y-x";
export var iconContainer = "_1y-q";
export var iconSwapper = "_1y-w";
export var navItem = "_1y-6";
export var navItemIcon = "_1y-f";
export var navProfile = "_1y-7";
export var notificationCountBadge = "_1y-j";
export var notificationDot = "_1y-r";
export var optionsContainer = "_1y-h";
export var primaryNav = "_1y-0";
export var primaryNavDivider = "_1y-v";
export var primaryNavResizeHandle = "_1y-2";
export var primaryNavResizing = "_1y-1";
export var primaryNavTabSection = "_1y-u";
export var primaryTab = "_1y-p";
export var primaryTabIconBox = "_1y-s";
export var secondaryNav = "_1y-3";
export var selected = "_1y-t";
export var settingsNav = "_1y-4";
export var settingsNavItems = "_1y-5";
export var show = "_1y-d";
export var sideNav = "_1y-l";
export var teamItem = "_1y-a";
export var userProfileItem = "_1y-b";